import React, { useState, useEffect } from 'react';

interface ImageWithFallbackProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    fallbackSrc?: string;
    fallbackStrategy?: 'image' | 'placeholder';
}

const ImageWithFallback: React.FC<ImageWithFallbackProps> = ({
    src,
    alt,
    className,
    fallbackSrc = '/logo.png', // Default fallback is the logo
    fallbackStrategy = 'image',
    ...props
}) => {
    const [imgSrc, setImgSrc] = useState<string | undefined>(src);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        setImgSrc(src);
        setHasError(false);
    }, [src]);

    const handleError = () => {
        if (!hasError) {
            setHasError(true);
            if (fallbackStrategy === 'image') {
                setImgSrc(fallbackSrc);
            }
        }
    };

    if (hasError && fallbackStrategy === 'placeholder') {
        return (
            <div className={`flex items-center justify-center bg-gray-100 text-gray-400 ${className}`}>
                <span className="material-symbols-outlined text-4xl">image_not_supported</span>
            </div>
        );
    }

    return (
        <img
            {...props}
            src={imgSrc || fallbackSrc}
            alt={alt}
            className={`${className} transition-opacity duration-300 ${hasError ? 'opacity-80 grayscale' : 'opacity-100'}`}
            onError={handleError}
        />
    );
};

export default ImageWithFallback;
